import { useState } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { useApp } from 'context/AppContext';
import {
  Container,
  Section,
  Logo,
  Tabs,
  Tab,
  TabLabel,
  UserProfile,
  Avatar,
  BackDrop,
  Popover,
  Box,
  Label,
  CoinsContainer,
  CoinsIcon,
  LogoutContainer,
  LogoutIcon,
  NavLinkWrapper,
  Header,
} from './Styles';
import { useAuth } from 'context/AuthContext';

const NavBar = () => {
  const { signout } = useAuth();
  const { state } = useApp();

  const { pathname } = useLocation();

  const [isPopoverOpen, setIsPopoverOpen] = useState(false);
  const { user } = state;
  const { picture, fNe: firstName, lNe: lastName, nie: nickName, lel: level, cBe } = user;

  const navTabs = [
    { path: '/home', label: 'Home' },
    { path: '/store', label: 'Store' },
    { path: '/faq', label: 'FAQ' },
  ];

  const togglePopover = () => setIsPopoverOpen(prev => !prev);

  const nameToDisplay = nickName.trim() ? nickName : firstName ? `${firstName} ${lastName}` : '';

  return (
    <Container>
      <Header>
        <Section>
          <Logo />
          <Tabs>
            {navTabs.map(({ path, label }) => {
              const isFaqTab = label === 'FAQ';

              return (
                <NavLinkWrapper key={path}>
                  <NavLink to={path}>
                    {({ isActive }) => {
                      const isTabActive = isFaqTab ? isActive || pathname.startsWith('/webview') : isActive;
                      return (
                        <Tab>
                          <TabLabel $isActive={isTabActive}>{label}</TabLabel>
                        </Tab>
                      );
                    }}
                  </NavLink>
                </NavLinkWrapper>
              );
            })}
          </Tabs>
        </Section>
        <UserProfile>
          <Avatar onClick={togglePopover} $avatar={picture?.data.url} />
          {isPopoverOpen && (
            <>
              <BackDrop onClick={togglePopover} />
              <Popover $isPopoverOpen={isPopoverOpen}>
                <Box>
                  <Label $isBreakWord={(firstName + lastName).length > 12}>{nameToDisplay}</Label>
                  <Label>Level {level}</Label>
                  <CoinsContainer>
                    <CoinsIcon />
                    <Label>{cBe.toLocaleString()}</Label>
                  </CoinsContainer>
                </Box>
                <LogoutContainer onClick={signout}>
                  Logout
                  <LogoutIcon />
                </LogoutContainer>
              </Popover>
            </>
          )}
        </UserProfile>
      </Header>
    </Container>
  );
};

export default NavBar;
